// extracted by mini-css-extract-plugin
module.exports = {"type":"MaschinenkundeEdit_type__wL89F"};